import { render, staticRenderFns } from "./PaginaRegistrazioniContabiliMinistero.vue?vue&type=template&id=404414b0"
import script from "./PaginaRegistrazioniContabiliMinistero.vue?vue&type=script&lang=js"
export * from "./PaginaRegistrazioniContabiliMinistero.vue?vue&type=script&lang=js"
import style0 from "./PaginaRegistrazioniContabiliMinistero.vue?vue&type=style&index=0&id=404414b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports